// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"styles_userDetails__1lz93","firstRow":"styles_firstRow__2BoAN"};